import request from '../../utils/request'

export default {
  getAll: data => request({
    url: '/api/services/app/payrollAssign/GetAll',
    method: 'get',
    params: data
  }),
  get: data => request({
    url: '/api/services/app/payrollAssign/Get',
    method: 'get',
    params: data
  }),
  getForEdit: data => request({
     url: '/api/services/app/payrollAssign/GetForEdit',
     method: 'get',
     params: data
  }),
  create: data => request({
    url: '/api/services/app/payrollAssign/Create',
    method: 'post',
    data: data
  }),
  update: data => request({
    url: '/api/services/app/payrollAssign/Update',
    method: 'put',
    data: data
  }),
  delete: function(data) {
    return request({
      url: '/api/services/app/payrollAssign/delete',
      method: 'delete',
      params: data
    })
  }
}
